import { render, staticRenderFns } from "./StoreImg2.vue?vue&type=template&id=37f82837&scoped=true"
import script from "./StoreImg2.vue?vue&type=script&lang=js"
export * from "./StoreImg2.vue?vue&type=script&lang=js"
import style0 from "./StoreImg2.vue?vue&type=style&index=0&id=37f82837&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f82837",
  null
  
)

export default component.exports